<button (click)="logout()" class="abx-nav-text-link">
  <mat-icon aria-hidden="true">logout</mat-icon>
  Log out
</button>
